import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as topojson from 'topojson-client';
import { GeoJSON, withLeaflet } from 'react-leaflet';

import { filterHHIsland } from '~/scripts/state/selectors';

function mergeTopojsonByKey(topoJsonData, geojson) {
  const key = Object.keys(topoJsonData.objects)[0];
  const topoJsonObject = topoJsonData.objects[key];
  const groups = topoJsonObject.geometries
    .reduce((res, item) => {
      const matchingFeat = geojson.features.find(feat => feat.properties.Wahlgebiet_ID.toString() === item.properties.Wahlgebiet_ID.toString());
      const currentValue = matchingFeat.properties.dissolveKey;

      item.properties.dissolveKey = currentValue;

      if (!res.includes(currentValue)) {
        res.push(currentValue);
      }

      return res;
    }, [])
    .map(value =>
      topojson.merge(
        topoJsonData,
        topoJsonObject.geometries.filter(d => d.properties.dissolveKey === value)
      )
    );

  // const groupedTopojson = {
  //   ...topoJsonData,
  //   objects: {
  //     geo: groups
  //   }
  // };

  return groups;
}

class Overlay extends PureComponent {
  static propTypes = {
    fill: PropTypes.bool,
    fillColor: PropTypes.string,
    weight: PropTypes.number,
    color: PropTypes.string,
    opacity: PropTypes.number,
    data: PropTypes.object,
    smoothFactor: PropTypes.number
  }

  static defaultProps = {
    fill: false,
    fillColor: 'transparent',
    weight: 1,
    color: '#eee',
    opacity: 1,
    data: null,
    smoothFactor: 0.5
  }

  state = {
    geojsonData: null
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.id !== this.props.id || !this.state.geojsonData) {
      const { data, geojson } = nextProps;
      const geojsonData = mergeTopojsonByKey(data, geojson);

      this.setState({ geojsonData });
    }
  }

  render() {
    if (!this.props.data || !this.state.geojsonData) {
      return null;
    }

    return (
      <GeoJSON
        data={this.state.geojsonData}
        fill={this.props.fill}
        fillColor={this.props.fillColor}
        weight={this.props.weight}
        color={this.props.color}
        opacity={this.props.opacity}
        smoothFactor={this.props.smoothFactor}
        className={this.props.className}
        key={this.props.id}
        filter={feat => filterHHIsland(feat)}
      />
    );
  }
}

export default withLeaflet(Overlay);
